import { createSvgIcon } from './createSvgIcon'

export default createSvgIcon(
  <>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-1 14H9V8h2zm4 0h-2V8h2z"></path>
  </>,
  'PauseCircle',
)
